import { Box, MediaBox, MediaFlex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useCallback } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import WizardHeaderLoading from "areas/product/jewlr/loaders/wizard-header-loading"
import { IS_JEWLR, isTestMode } from "helpers/application"
import scrollToElement from "helpers/scroll-to-element"

import ProductPrice from "../product-price"

import Badge from "./badge"
import Financing from "./financing"
import PromoDesktop from "./promo-desktop"
import Ratings from "./ratings"

const ProductTitle = styled(Typography).attrs({
  as: "h1",
  fontSize: { _: "18px", tablet: "24px" },
  fontWeight: { _: "700", tablet: "300" },
  lineHeight: { _: "22px", tablet: "28px" },
  mb: 1,
})``

const InternalWizardHeader = ({ price, title, wizardLoading }) => {
  const handleRatingsClick = useCallback(() => {
    scrollToElement("#product-reviews", 350)
    if (!isTestMode) {
      dataLayer.push({
        event: "clicked-reviews-count-pdp",
      })
    }
  }, [])

  const financing = <Financing price={price} />
  const ratings = <Ratings handleClick={handleRatingsClick} />

  return (
    <Box as="section" mb={{ _: 2, tablet: "12px" }}>
      <PromoDesktop />
      {wizardLoading ? (
        <WizardHeaderLoading />
      ) : (
        <>
          <MediaBox greaterThanOrEqual="tablet">
            <Badge />
          </MediaBox>
          <ProductTitle>{title}</ProductTitle>
          {IS_JEWLR() && <MediaBox lessThan="tablet">{ratings}</MediaBox>}
          <ProductPrice />
          {IS_JEWLR() && (
            <Box
              minHeight={
                sl.config.klarna_osm_pdp
                  ? { _: "38px", tablet: "21px" }
                  : "18px"
              }
            >
              <MediaBox lessThan="tablet"> {financing}</MediaBox>
              <MediaFlex
                alignItems={sl.config.klarna_osm_pdp ? "center" : "end"}
                gap={1}
                greaterThanOrEqual="tablet"
                justifyContent="space-between"
              >
                {ratings}
                {financing}
              </MediaFlex>
            </Box>
          )}
        </>
      )}
    </Box>
  )
}

InternalWizardHeader.propTypes = {
  price: PropTypes.number,
  title: PropTypes.string,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    price: state.wizardUI.currentPricing
      ? state.wizardUI.currentPricing.price_to_display * 100
      : 0,
    title: state.wizard.loading ? "" : state.wizard.title,
    wizardLoading: state.wizard.loading,
  }
}

const WizardHeader = connect(mapStateToProps)(InternalWizardHeader)

export default WizardHeader
